const KEYUP_EVENT = 'keyup';
const ESC_CODE = 27;

const ESCAPE_KEY_HANDLER = function (e) {
  if (e.type === KEYUP_EVENT && e.keyCode === ESC_CODE) {
    const handler = this.escapeKeyHandler;
    if (handler === undefined) {
      const componentName = this.$options.name || 'this component';
      console.warn(`[EscapeKeyMixin]: you must define a function 'escapeKeyHandler' on ${componentName} to handle the escape key event.`) // eslint-disable-line
    } else handler(e);
  }
};

export default {
  mounted() {
    document.body.addEventListener(KEYUP_EVENT, ESCAPE_KEY_HANDLER.bind(this));
  },
  destroyed() {
    document.removeEventListener(KEYUP_EVENT, ESCAPE_KEY_HANDLER.bind(this));
  },
};
